module.exports = __webpack_public_path__ + "fontawesome-webfont.32400f4e08932a94d8bf.eot";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/fonts/fontawesome-webfont.eot
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.eot
// module chunks = styles